<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageLeft>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
              <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/features_and_amenities/Wifi.jpg" alt=""></transition></div>
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Features & Amenities / Leading Edge Technology" h1="Wi-Fi & Cell Coverage" />                    
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                     <div class="text-content">
                        <Accordian v-for="(accordian, key) in accordians" :key="key" :preview="accordian.preview" :icon="accordian.icon" :info="accordian.info"/>
                     </div>
                  </transition>
                </div>
            </div>
        </div>
    </template>
    </PageLeft>    
  </div>
</template>

<script>
//TODO
import PageLeft from "@/patterns/PageLeft.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import Accordian from "@/patterns/Accordian.vue";
export default {
  name: "WifiAndCellCoverage",
  components: { PageLeft, TitleContent, Accordian },
  data: () => ({
    scrollContent: false,   
    accordians :[
      {
        "preview" : "Enhanced cell phone coverage powered by 29 MatSing ball antennas",
        "icon" : "features_and_amenities/icon-white_cell-coverage.svg",
        "info" : [
          "Uninterrupted coverage for maximum capacity events",
          "Best cell phone coverage of any stadium in the nation"
        ]
      },      
      {
        "preview" : "Next-generation optical fan facing & backstage Wi-Fi connectivity",
        "icon" : "features_and_amenities/icon-white_wifi.svg",
        "info" : [
          "Available throughout building, backstage complex, and covered bus/truck parking area as well as parking lots attached to the stadium",
          "Wi-Fi 6 provides the best connectivity experience to mobile devices in high-density environments",
          "Hardline available wherever needed backstage"
        ]
      },
    ] 
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>